import { SERVER_URL } from "./config";

export const createResponse = (
  success,
  data = null,
  error = null,
  status = null
) => ({
  success,
  data,
  error,
  status,
});

export const handleResponse = async (response) => {
  if (response.ok) {
    if (response.status === 204) {
      // No content response
      return createResponse(true, null, "no_content", response.status);
    }
    const data = await response.json();
    return createResponse(true, data, "ok", response.status);
  }
  let errorMessage = "request_failed";
  switch (response.status) {
    case 401:
      errorMessage = "unauthorized";
      break;
    case 403:
      errorMessage = "request_failed";
      break;
    case 404:
      errorMessage = "not_found";
      break;
    default:
      errorMessage = `Unexpected error: ${response.status}`;
      break;
  }
  return createResponse(false, null, errorMessage, response.status);
};

export const fetchAPI = async (endpoint, options = {}) => {
  const url = `${SERVER_URL}${endpoint}`;

  const defaultOptions = {
    method: "GET",
    headers: {
      Accept: "application/json"      
    },
  };

  try {
    const mergedOptions = { ...defaultOptions, ...options };

    // Merge headers properly if both exist
    if (options.headers) {
      mergedOptions.headers = { ...defaultOptions.headers, ...options.headers };
    }

    const response = await fetch(url, mergedOptions);
    return await handleResponse(response);
  } catch (error) {
    console.error(`API request error for ${endpoint}:`, error);
    return createResponse(false, null, "network_error");
  }
};

export const fetchWithAuth = async (endpoint, options = {}, accessToken) => {
  if (!accessToken) {
    return createResponse(false, null, "no_access_token");
  }

  const defaultOptions = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  };
  const authOptions = { ...defaultOptions, ...options };
  if (options.headers) {
    authOptions.headers = { ...defaultOptions.headers, ...options.headers };
  }

  return await fetchAPI(endpoint, authOptions);
};

export const postFormWithAuth = async (endpoint, options = {}, accessToken) => {
  const url = `${SERVER_URL}${endpoint}`;
  if (!accessToken) {
    return createResponse(false, null, "no_access_token");
  }

  const defaultOptions = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  try {
    const mergedOptions = { ...defaultOptions, ...options };
    const response = await fetch(url, mergedOptions);
    return await handleResponse(response);
  } catch (error) {
    console.error(`API request error for ${endpoint}:`, error);
    return createResponse(false, null, "network_error");
  }
}
